'use client'

import { createContext, useContext } from 'react'

import type { StockOverall } from '@/types/stock'

export interface StockContextValues {
  stock: StockOverall
}

export const StockContext = createContext<StockContextValues>({} as StockContextValues)

export const StockProvider = ({
  children,
  stock,
}: {
  children: React.ReactNode
  stock: StockOverall
}) => {
  return <StockContext.Provider value={{ stock }}>{children}</StockContext.Provider>
}

export const useStockContext = () => {
  return useContext(StockContext)
}
